<fieldset [formGroup]="parentFormGroup">
  <legend>
    <div>
      <span i18n>Exam Type</span>
      <div>
        @if (itemTreeExamTypeForm.value !== null) {
          <eas-editor-booking-item-inheritable-type-badge [inheritableType]="'set'">
          </eas-editor-booking-item-inheritable-type-badge>
        }
        @if (isDeletable()) {
          <button
            mat-icon-button
            aria-label="Delete exam type"
            i18n-aria-label
            (click)="onDelete()">
            <mat-icon inline>delete</mat-icon>
          </button>
        }
      </div>
    </div>
  </legend>
  <p i18n>
    Please define the type of the exam you are creating,
    define the connection to the exam delivery system and the risr/assess blueprint to use.
  </p>
  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label i18n>Select exam type for College exam</mat-label>
      <mat-select id="exam-type" formControlName="examType">
        <mat-option value=""><em i18n></em></mat-option>
        @for (option of examTypeNames; track option) {
          <mat-option [value]="option.id">
            {{ option.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (isLoftOsceSelected()) {
      <p i18n class="subtitle-help-text">
             Individual on demand oral exam requires one candidate and one examiner. Please ensure an examiner is specified during the workflow and associated workflow action to create exam in risr/assess.
    </p>
      }

      @if (isRisrAssessExamType()) {
        <mat-form-field appearance="outline">
          <mat-label i18n>Select risr/assess instance for exam delivery</mat-label>
            <mat-select id="connection-id" formControlName="risrAssessConnectionId" required>
              <mat-option value=""><em i18n></em></mat-option>
              @for (connection of risrAssessConnections; track connection) {
                <mat-option [value]="connection.id">
                  {{ connection.name }}
                </mat-option>
              }
            </mat-select>
            @if (parentFormGroup.get('risrAssessConnectionId')?.errors?.required) {
              <mat-error i18n>
                     risr/assess connection is required
      </mat-error>
              }
            </mat-form-field>
          }
          @if (isRisrConnectionSelected()) {
            <mat-form-field appearance="outline">
              <mat-label i18n>Select risr/assess exam blueprint
        @if (areBlueprintsLoading) {
<mat-progress-spinner diameter="16" mode="indeterminate" color="primary"
                              style="vertical-align: middle;"></mat-progress-spinner>
}
      </mat-label>
                <mat-select id="risr-assess-blueprint-id" formControlName="risrAssessBlueprintId"
                  [required]="isLoftExamType()" [disabled]="areBlueprintsLoading">
                  <mat-option value=""><em i18n></em></mat-option>
                  @for (blueprint of risrAssessBlueprints; track blueprint) {
                    <mat-option [value]="blueprint.id">
                      {{ blueprint.name }}
                    </mat-option>
                  }
                  @if (!risrAssessBlueprints || risrAssessBlueprints?.length === 0) {
                    <mat-option disabled>
                      <em i18n>No mapped risr/advance blueprints available</em>
        </mat-option>
                  }
                </mat-select>
                @if (parentFormGroup.get('risrAssessBlueprintId')?.errors?.required) {
                  <mat-error i18n>
                       risr/assess blueprint is required for Individual on demand exam type
      </mat-error>
                  }
                </mat-form-field>
              }

              @if (isRisrConnectionSelected() && isLoftExamType()) {
                <mat-form-field appearance="outline">
                  <mat-label i18n>Item set generation method</mat-label>
                    <mat-select id="item-set-selection-method" formControlName="risrAssessItemSetGenerationMethod" required>
                      <mat-option [value]="'autogenerated'" i18n>Autogenerated</mat-option>
                        <mat-option [value]="'specific'" i18n>Choose specific item set</mat-option>
                        </mat-select>
                        @if (parentFormGroup.get('risrAssessItemSetGenerationMethod')?.errors?.required) {
                          <mat-error i18n>
                               Selecting an item set generation method is required
      </mat-error>
                          }
                        </mat-form-field>
                      }

                      @if (isRisrAssessItemSetGenerationMethodSelected()) {
                        <mat-form-field appearance="outline">
                          <mat-label i18n>
                               {{ parentFormGroup.get('risrAssessItemSetGenerationMethod')?.value === 'autogenerated' ? 'Select risr/assess backup itemset' : 'Select risr/assess itemset' }}
        @if (areItemSetsLoading) {
<mat-progress-spinner diameter="16" mode="indeterminate" color="primary"
                              style="vertical-align: middle;"></mat-progress-spinner>
}
      </mat-label>
                            <mat-select id="risr-assess-itemset" formControlName="risrAssessItemSetNumber" [required]="true"
                              [disabled]="areItemSetsLoading">
                              <mat-option value=""><em i18n></em></mat-option>
                              @for (itemset of risrAssessItemSets; track itemset) {
                                <mat-option [value]="itemset.id">
                                  {{ itemset.name }}
                                </mat-option>
                              }
                              @if (!risrAssessItemSets || risrAssessItemSets?.length === 0) {
                                <mat-option disabled>
                                  <em i18n>No itemsets available</em>
        </mat-option>
                              }
                            </mat-select>
                            @if (parentFormGroup.get('risrAssessItemSetNumber')?.errors?.required) {
                              <mat-error i18n>
                                 risr/assess itemset is required for Individual on demand exam type
      </mat-error>
                              }
                            </mat-form-field>
                          }
                        </div>
                      </fieldset>
